import React from 'react';

/**
 * Specialized component for rendering academic profile links
 * Handles the specific structure of academic links with descriptions
 */
const AcademicProfileList = ({ profiles, title = 'Academic Profile' }) => {
  if (!profiles || !profiles.length) return null;

  return (
    <div>
      <span>{title}</span>
      <ul>
        {profiles.map((profile, index) => (
          <li key={index}>
            <a 
              href={profile.url} 
              target='_blank' 
              rel='noreferrer'
              aria-label={`Visit ${profile.title} academic profile`}
            >
              {profile.title}
            </a>
            <br />
            {profile.description}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AcademicProfileList;